import { useContext, FC } from 'react';
import { NotificationsVisibleContext } from '../../context';
import { Notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
  isWidget?: boolean;
}

const Notification: FC<Props> = ({ isWidget = false }): JSX.Element => {
  const { isOpen } = useContext(NotificationsVisibleContext);
  const [t] = useTranslation('common');
  const zIndexNotificationValue = isWidget ? '10001' : '';

  return (
    <Notifications
      className={styles.notifications}
      tabIndex={isOpen ? 0 : -1}
      aria-label={`${t('notificationsLabel')}`}
      role={'alert'}
      zIndex={zIndexNotificationValue}
    />
  );
};

export default Notification;
